import { getTradeTime, Trade } from '../entities/shared';
import EntityStore from './entity';

const MAX_CLOSED_TRADES = 50;

export default class TradesStore extends EntityStore<Trade> {
  constructor() {
    const sortComparer = (tradeA: Trade, tradeB: Trade) =>
      getTradeTime(tradeB) - getTradeTime(tradeA);

    super({ sortComparer });
  }

  /** All trades for a given RFQ, newest first (store is sorted by time). */
  selectByRfqId(rfqId: Trade['rfq_id']): readonly Trade[] {
    return this.selectAll().filter((trade) => trade.rfq_id === rfqId);
  }

  handleTrade(trade: Trade) {
    this.setOne(trade); // Add the new trade

    const trades = this.selectAll(); // Trades sorted by time

    if (trades.length > MAX_CLOSED_TRADES) {
      const tradesToRemove = trades.slice(MAX_CLOSED_TRADES);

      for (const oldTrade of tradesToRemove) {
        this.removeOne(oldTrade.id, { permanent: true });
      }
    }
  }
}
